import DOMPurify from "isomorphic-dompurify";

export function sanitize(content, config) {
  return DOMPurify.sanitize(content, config);
}
